import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { axiosInstance } from './axios';

export type PutBackKind = 'REPAIRED' | 'FOUND';

/** One confirmation from the Hub "Put back an item" screen. */
export interface IPutBackRequest {
  /** Client-made UUID, one per confirmation; resent unchanged on retry or double tap. */
  requestKey: string;
  /** The Unicom facility code, e.g. DWARKA_WH. */
  facilityCode: string;
  skuCode: string;
  kind: PutBackKind;
  /** REPAIRED: the shelf the piece was booked damaged on. FOUND: the shelf it turned up on. */
  fromShelf?: string;
  /** REPAIRED only: the shelf the good piece goes to. */
  toShelf?: string;
}

/**
 * Hub put-back: a damaged piece was repaired, or a not-found piece turned up. SCM records the
 * request under its requestKey and sends the Unicom writes once; the same key with the same
 * details returns the stored record and never re-sends.
 *
 * Every method returns the SCM envelope `{ status, data }`. A failed envelope is rejected by the
 * axios interceptor with `status.message` as the error message.
 */
class PutBackApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/wms/put-back');
  }

  /** Records the put-back and sends its Unicom writes; returns the record with each write's outcome. */
  async createPutBack(payload: IPutBackRequest) {
    const response = await axiosInstance.post(`${this.baseURL}`, payload);
    return response.data;
  }

  /** The record stored under this key. Read only: it never sends anything to Unicom. */
  async getPutBack(requestKey: string) {
    const response = await axiosInstance.get(`${this.baseURL}/${encodeURIComponent(requestKey)}`);
    return response.data;
  }
}

export default PutBackApiClient;
